<template>
  <div class="askbox">
    <input type="text" class="asktitle" placeholder="写下你的问题，准确地描述问题更容易得到解答" v-model="question" />
    <!-- <img src="../../assets/community/image_icon.png" alt="" > -->
    <!-- <span class="icon-pic custom-icon" title="图片" @click="insertImgClick($event)">e</span> -->
    <quill-editor
      class="editor"
      ref="myTextEditor"
      v-model="content"
      :options="editorOption"
      @blur="onEditorBlur($event)"
      @focus="onEditorFocus($event)"
      @ready="onEditorReady($event)"
      @change="onEditorChange($event)"
    ></quill-editor>
    <p class="textlength">
      <span>{{contentLen}}</span>/500
    </p>
    <div class="release" @click="release">修改问题</div>
  </div>
</template>

<script>
import http from "axios";
import md5 from "js-md5";

const uploadConfig = {
  name: "img", // 必填参数 文件的参数名
  accept: "image/png, image/gif, image/jpeg" // 可选 可上传的图片格式
};
const toolbarOptions = [
  // [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
  // ["bold", "italic"],
  ["image"]
];

export default {
  data() {
    return {
      content: null,
      editorOption: {},
      surPlusLen: 0,
      maxLen: 500,
      question: null,
      contentLen: 0,
      handlers: {},
      set_question:this.msg,
      set_content:null
    };
  },
  props: ["msg"],
  created() {
    let that = this;
    let isie = this.isIE()
    console.log(isie)
    this.iswhite = this.$store.state.iswhitelist;
    if(!isie){
    this.handlers = {
      image: function image() {
        var self = this;
        // console.log("1a1a1a")
        var fileInput = self.container.querySelector(
          "input.ql-image[type=file]"
        );
        if (fileInput === null) {
          fileInput = document.createElement("input");
          fileInput.setAttribute("type", "file");
          // console.log(uploadConfig)
          // 设置图片参数名
          if (uploadConfig.name) {
            fileInput.setAttribute("name", uploadConfig.name);
          }
          // 可设置上传图片的格式
          fileInput.setAttribute("accept", uploadConfig.accept);
          fileInput.classList.add("ql-image");
          // 监听选择文件
          fileInput.addEventListener("change", function() {
            // var data = success;
            let file = fileInput.files[0];
            // console.log(file)
            var reader = new FileReader();
            reader.readAsDataURL(file);
            let newfile = ''
            reader.onload = function (e) { 
              newfile = this.result;
              let params = {
                img:newfile
              }
              that.$axios.post('community/upload_img',params)
              .then(function(res){
                // console.log(res)
                var url = res.data.data.img
                self.quill.insertEmbed(length, "image", url);
                self.quill.setSelection(length + 1);
              })
              // document.getElementById("data").innerText=this.result.substring(this.result.indexOf(',')+1); 
            }
          });
        }
        fileInput.click();
      }
    }
    }
    this.editorOption = {
      modules: {
        toolbar: {
          // [ "image"], // 链接、图片、视频
          container: toolbarOptions,
          handlers: this.handlers
        } //工具菜单栏配置
      },
      placeholder: "输入问题背景详细信息", //提示
      readyOnly: false, //是否只读
      theme: "snow", //主题 snow/bubble
      syntax: true
    };
  },
  mounted(){
    // console.log(this.set_question)
    // console.log(this.msg)

  },
  methods: {
    isIE() {
        if(!!window.ActiveXObject || "ActiveXObject" in window){
          return true;
        }else{
          return false;
    　　 }
    },
    release() {
      let that = this;
      // console.log(this.content)
      if (this.question.trim()) {
        let params = {
          user_id: parseInt(this.$store.state.user_id),
          question_title: this.question,
          question_content: this.content,
          question_id:parseInt(this.set_question.question_id)
        };
        var sign = addstamp(params)
        delete params.token
        params['sign'] = sign
        // console.log(params)
        this.$axios.put("community/question", params).then(function(res) {
          if (res.data.status_code == 200) {
            // console.log(res)
            var data = false
            that.$emit('funct',data)
            $("body").css({ overflow: "auto", "margin-right": "0px" });
          }
        });
      }
    },
    insertImgClick(e) {
      // console.log("insertImgClick......");
    },
    fileInsert(e) {
      // console.log("fileInsert......");
    },
    onEditorBlur(e) {
      // console.log("onEditorBlur......");
    },
    onEditorFocus(e) {
      // console.log("onEditorFocus......");
    },
    onEditorReady(e) {
      // console.log("onEditorReady......");
    },
    // 编辑器文本发生变化
    onEditorChange(event) {
      // console.log("------onEditorChange------");
      event.quill.deleteText(500,4)
      if(this.content == ''){
        this.contentLen = 0
      }else{
        this.contentLen = event.quill.getLength()-1
      }
    }
  },
  watch: {
    question(newp, oldp) {
      if (newp.length > 50) {
        this.question = this.question.substring(0, 50);
      }
    },
    msg(val, oldval){
        // console.log(val)
        this.set_question = val
        this.content = val.question_content
        this.question = val.question_title
    }
  }
};
</script>

<style lang="scss" scoped>
.askbox {
  width: 680px;
  max-height: calc(100% - 40px);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  // top: calc(50% - 190px);
  // left: calc(50% - 340px);
  // border: 1px solid red;
  background: #fff;
  border-radius: 20px;
  .asktitle {
    width: 600px;
    height: 44px;
    font-size: 16px;
    display: inline-block;
    margin: 0 auto;
    border: none;
    border-radius: 8px;
    background: rgba(244, 244, 244, 1);
    margin-top: 35px;
    margin-left: 40px;
    text-indent: 20px;
    color: #ad896b;
    &::placeholder {
      color: #ad896b;
    }
  }
}
.textlength {
  font-size: 18px;
  color: #999;
  margin-top: 22px;
  margin-left: 48px;
  span {
    color: #333;
  }
}
.release {
  width: 117px;
  height: 44px;
  background: #d55d3a;
  color: #fff;
  font-size: 18px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  border-radius: 10px;
  text-align: center;
  line-height: 44px;
  margin: 0px 37px 37px;
  float: right;
  cursor: pointer;
}

.editor {
  line-height: normal !important;
  min-height: 140px;
  max-height: 612px;
  width: 605px;
  margin: 0 auto;
  // border: 1px solid red;
  // border-radius:10px;
  // margin-top: 45px;
}
.ql-editor {
  font-size: 16px;
  min-height: 300px;
  max-height: 540px !important;
  border: 1px solid green !important;
}
.ql-snow .ql-tooltip[data-mode="link"]::before {
  content: "请输入链接地址:";
}
.ql-snow .ql-tooltip.ql-editing a.ql-action::after {
  border-right: 0px;
  content: "保存";
  padding-right: 0px;
}
.askbox .ql-editor {
  font-size: 16px;
}
.ql-snow .ql-tooltip[data-mode="video"]::before {
  content: "请输入视频地址:";
}

.ql-snow .ql-picker.ql-size .ql-picker-label::before,
.ql-snow .ql-picker.ql-size .ql-picker-item::before {
  content: "14px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="small"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="small"]::before {
  content: "10px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="large"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="large"]::before {
  content: "18px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="huge"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="huge"]::before {
  content: "32px";
}

.ql-snow .ql-picker.ql-header .ql-picker-label::before,
.ql-snow .ql-picker.ql-header .ql-picker-item::before {
  content: "文本";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
  content: "标题1";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
  content: "标题2";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
  content: "标题3";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
  content: "标题4";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
  content: "标题5";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
  content: "标题6";
}

.ql-snow .ql-picker.ql-font .ql-picker-label::before,
.ql-snow .ql-picker.ql-font .ql-picker-item::before {
  content: "标准字体";
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="serif"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="serif"]::before {
  content: "衬线字体";
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="monospace"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="monospace"]::before {
  content: "等宽字体";
}
</style>



// WEBPACK FOOTER //
// src/components/public/setask.vue